import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from 'react-bootstrap';

var buildButton = function buildButton() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      func = _ref.func,
      label = _ref.label,
      bsPrefix = _ref.bsPrefix,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _ref.props;

  if (!func) return null;
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    onClick: func,
    bsPrefix: bsPrefix,
    variant: variant,
    disabled: disabled
  }), label);
};

buildButton.displayName = "buildButton";
export { buildButton };